import Swal from "sweetalert2"
import translations from "translations"
import * as I18n from "services/i18n"

// As listas vêm do servidor, a partir do registry — não são duplicadas aqui.
function moduleList(button, key) {
  return String(button.data(key) || '').split(',').filter(Boolean)
}

// Ids dos blocos marcados. Os checkboxes de bloco usam o próprio nome do módulo
// como id; `comments` fica fora do grupo `.options-list`, por isso entra à parte.
function checkedModules() {
  return $('.options-list:checked, #comments:checked').map(function () { return this.id }).get()
}

// O botão aparece só quando os blocos marcados são exatamente os enviáveis E os
// obrigatórios estão entre eles. O servidor recusa de qualquer forma; isto evita
// o usuário tentar.
function refreshCustomReportButton() {
  const button = $('#custom-report-submit')
  if (!button.length) return

  const supported = moduleList(button, 'supported-modules')
  const required = moduleList(button, 'required-modules')
  const checked = checkedModules()

  const hasUnsupported = checked.some(function (id) { return supported.indexOf(id) === -1 })
  const hasAllRequired = required.every(function (id) { return checked.indexOf(id) !== -1 })

  button.toggleClass('hide', hasUnsupported || !hasAllRequired)
}

export function handleCustomReport() {
  // `setTimeout` porque "selecionar todos" marca os checkboxes por `.prop()`,
  // que não dispara `change` — precisamos ler o estado depois dos outros handlers.
  $(document).on('change', '.options-list, #comments, #checkbox_all_options', function () {
    setTimeout(refreshCustomReportButton, 0)
  })

  refreshCustomReportButton()

  $(document).on('click', '#custom-report-submit', function () {
    const button = $(this)
    const form = $('#reports-generator-form')

    button.prop('disabled', true)

    // A aba precisa ser aberta no clique: `window.open` dentro do callback do
    // ajax perde o gesto do usuário e o bloqueador de pop-up barra. Ela abre na
    // página de espera do Stant e é substituída pela URL do parceiro na resposta.
    const reportTab = window.open(button.data('waiting-url'), '_blank')

    $.ajax({
      url: button.data('url'),
      method: 'POST',
      dataType: 'json',
      data: form.serialize(),
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
    })
      .done(function (response) {
        // Sem `url` o relatório foi aceito mesmo assim — só não há página para abrir.
        if (!response.url) {
          if (reportTab) reportTab.close()
          Swal.fire({ type: 'success', text: response.message })
          return
        }

        if (!reportTab) {
          Swal.fire({
            type: 'info',
            title: I18n.t(translations(), 'reports.reports_generator.custom_report.popup_blocked'),
            html: I18n.t(translations(), 'reports.reports_generator.custom_report.popup_blocked_hint') +
              '<br><br><a href="' + response.url + '" target="_blank" rel="noopener">' +
              I18n.t(translations(), 'reports.reports_generator.custom_report.open_report') + '</a>'
          })
          return
        }

        reportTab.location.href = response.url
      })
      .fail(function (xhr) {
        if (reportTab) { reportTab.close() }

        const message = (xhr.responseJSON && xhr.responseJSON.message) ||
          I18n.t(translations(), 'reports.reports_generator.custom_report.unavailable')

        Swal.fire({ type: 'error', text: message })
      })
      .always(function () {
        button.prop('disabled', false)
      })
  })
}
